import { render } from "./BaseVideo.vue?vue&type=template&id=7c316d8a"
import script from "./BaseVideo.vue?vue&type=script&lang=js"
export * from "./BaseVideo.vue?vue&type=script&lang=js"

import "./BaseVideo.vue?vue&type=style&index=0&id=7c316d8a&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__